<template>
  <v-container fluid>
    <v-card>
      <v-container class="ma-0 pa-0" fluid>
        <v-container grid-list-xs fluid class="mb-0 pb-0" style="padding: 5px;">
          <v-layout row style="padding: 10px;">
            <v-flex md6>
              <v-text-field
                ref="form"
                class="mr-1"
                append-icon="search"
                label="Search by Control no. or Card no."
                v-model="searchItem"
                clearable
                hide-details
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <!-- <v-select
            v-model="theTableStyle"
            :items="tableItems"
            prepend-icon="table_chart"
            label="Type of Table"
            style="width: 0.10%;"
            ></v-select>-->

            <v-btn fab dark small color="amber darken-2" @click="playData()">
              <v-icon dark>play_arrow</v-icon>
            </v-btn>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="downloadExcel()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel File</span>
            </v-tooltip>

            <refresh-button @refresh="refreshData()"></refresh-button>
          </v-layout>

          <v-layout row style="padding: 10px;">
            <v-layout>
              <v-flex md3 style="padding: 15px;">
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-right="40"
                  lazy
                  :disabled="queryParams.search ? true : false"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    :disabled="queryParams.search ? true : false"
                    v-model="dateFrom"
                    label="Date From"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="dateFrom"
                    :max="dateTo"
                    min="1950-01-01"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md3 style="padding: 15px;">
                <v-menu
                  ref="menu1"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  lazy
                  :disabled="queryParams.search ? true : false"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    :disabled="queryParams.search ? true : false"
                    v-model="dateTo"
                    label="Date To"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="dateTo"
                    :max="new Date().toISOString().substr(0, 10)"
                    :min="dateFrom"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <!-- <v-flex md6>
              <v-text-field
                ref="form"
                class="mr-1"
                prepend-icon="search"
                label="Search"
                v-model="searchItem"
                clearable
                hide-details
              ></v-text-field>
            </v-flex>-->
            <v-spacer></v-spacer>
            <!-- <v-select
            v-model="theTableStyle"
            :items="tableItems"
            prepend-icon="table_chart"
            label="Type of Table"
            style="width: 0.10%;"
            ></v-select>-->
          </v-layout>

          <message-dialog
            :dialog="messageDialog"
            :title="messageTitle"
            :message="messageText"
            @save="action === 'align' ? saveAlignTicket() : ''"
            @close="closeMessageDialog"
            :loading="messageLoading"
          ></message-dialog>

          <!-- Filter -->
          <!-- <v-divider></v-divider> -->
          <v-layout row>
            <v-flex sm4 md4>
              <v-btn flat @click="openFilterExpansion">
                <v-icon class="mr-3">{{
                  openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down"
                }}</v-icon>
                <span>Filter {{ title }}</span>
              </v-btn>
            </v-flex>
          </v-layout>

          <filter-panel :openFilter="openFilter">
            <v-flex md3>
              <v-select
                v-model="filterCompany"
                :items="filterCompanies"
                label="By Company"
                clearable
                solo
              ></v-select>
            </v-flex>
            <v-flex md3>
              <v-select
                v-model="filterSubCompany"
                :items="filterSubCompanies"
                label="By Sub-Company"
                clearable
                solo
              ></v-select>
            </v-flex>
            <v-flex md3>
              <v-select
                v-model="filterPaymentType"
                :items="filterPaymentTypes"
                label="By Payment Type"
                clearable
                solo
              ></v-select>
            </v-flex>
          </filter-panel>

          <!-- <v-container grid-list-lg fluid style="padding: 0px;" class="pt-3">
          </v-container>-->
        </v-container>
        <v-divider></v-divider>

        <bottom-scroll @on-bottom="loadMore" :offset="queryParams.offset">
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align,
                  ]"
                >
                  <span>{{ header.text.toUpperCase() }}</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td :class="['text-xs-center no-wrap']">
                {{ props.index + 1 }}
              </td>
              <td :class="['text-xs-left text-uppercase no-wrap']">
                {{
                  props.item.sub_company ? props.item.sub_company.code : "--"
                }}
              </td>
              <td :class="['text-xs-left text-uppercase no-wrap']">
                {{ props.item.device ? props.item.device.device_serial : "--" }}
              </td>
              <td :class="['text-xs-left no-wrap']">
                {{ props.item.control_no }}
              </td>
              <td :class="['text-xs-left no-wrap']">
                {{
                  props.item.custom_control_no
                    ? props.item.custom_control_no
                    : "--"
                }}
              </td>
              <td :class="['text-xs-right']">
                {{ props.item.trip_no }}
              </td>
              <td :class="['text-xs-center no-wrap']">
                {{
                  props.item.datetimestamp
                    ? $dateFormat(props.item.datetimestamp, "YYYY-MM-DD")
                    : "--"
                }}
              </td>
              <td :class="['text-xs-center no-wrap']">
                {{
                  props.item.datetimestamp
                    ? $dateFormat(props.item.datetimestamp, "HH:mm")
                    : "--"
                }}
              </td>
              <td :class="['text-xs-left no-wrap']">
                {{ props.item.ticket_no }}
              </td>
              <td :class="['text-xs-left no-wrap']">
                {{ props.item.or_no }}
              </td>
              <td :class="['text-xs-left no-wrap']">
                {{ props.item.ticket_type ? "BAGGAGE" : "PASSENGER" }}
              </td>
              <td :class="['text-xs-left text-uppercase no-wrap']">
                {{
                  props.item.payment_type ? props.item.payment_type.name : "--"
                }}
              </td>
              <td :class="['text-xs-left no-wrap']">
                {{ props.item.card_no ? props.item.card_no : "--" }}
              </td>
              <td :class="['text-xs-left text-uppercase no-wrap']">
                {{
                  props.item.passenger_type
                    ? props.item.passenger_type.name
                    : "--"
                }}
              </td>

              <td :class="['text-xs-left text-uppercase no-wrap']">
                {{ props.item.place_from }}
              </td>
              <td :class="['text-xs-left text-uppercase no-wrap']">
                {{ props.item.place_to }}
              </td>
              <td :class="['text-xs-left text-uppercase no-wrap']">
                {{
                  props.item.route
                    ? props.item.route.bound
                      ? props.item.route.bound.name
                        ? props.item.route.bound.name
                        : "--"
                      : "--"
                    : "--"
                }}
              </td>

              <td :class="['text-xs-right']">
                {{ props.item.km_from }}
              </td>

              <td :class="['text-xs-right']">
                {{ props.item.km_to }}
              </td>

              <td :class="['text-xs-left no-wrap']">
                {{ `${props.item.lat}, ${props.item.long}` }}
              </td>

              <td :class="['text-xs-right']">
                {{
                  props.item.amount || props.item.amount >= 0
                    ? props.item.amount.toFixed(2)
                    : "--"
                }}
              </td>
              <td :class="['text-xs-left text-uppercase no-wrap']">
                {{ props.item.status ? "CANCELLED" : "NORMAL" }}
              </td>
            </template>
          </v-data-table>
        </bottom-scroll>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import XLSX from "xlsx";
const now = new Date();

export default {
  data() {
    return {
      //filter
      openFilter: false,
      filterCompanies: [],
      filterCompany: null,
      filterSubCompanies: [],
      filterSubCompany: null,
      filterPaymentTypes: [
        {
          text: "CASH",
          value: "CASH",
        },
        {
          text: "CARD",
          value: "CARD",
        },
      ],
      filterPaymentType: null,
      title: "Ticket Wireless",

      timeOut: null,
      theTableStyle: false,
      tableItems: [
        {
          text: "Default Table",
          value: false,
        },
        {
          text: "Grid Style Table",
          value: true,
        },
      ],
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Company Code",
          align: "center",
          sortable: false,
        },
        {
          text: "Device Serial",
          align: "left",
          sortable: false,
        },
        {
          text: "Control No",
          align: "left",
          sortable: false,
        },
        {
          text: "Custom Control No.",
          align: "left",
          sortable: false,
        },
        {
          text: "Trip No",
          align: "right",
          sortable: false,
        },
        {
          text: "Date",
          align: "center",
          sortable: false,
        },
        {
          text: "Time",
          align: "center",
          sortable: false,
        },
        {
          text: "Ticket No",
          align: "left",
          sortable: false,
        },
        {
          text: "OR No",
          align: "left",
          sortable: false,
        },
        {
          text: "Ticket Type",
          align: "left",
          sortable: false,
        },
        {
          text: "Transaction Type",
          align: "left",
          sortable: false,
        },
        {
          text: "Card No.",
          align: "left",
          sortable: false,
        },
        {
          text: "Passenger Type",
          align: "left",
          sortable: false,
        },
        {
          text: "Place From",
          align: "left",
          sortable: false,
        },
        {
          text: "Place To",
          align: "left",
          sortable: false,
        },
        {
          text: "Bound",
          align: "left",
          sortable: false,
        },
        {
          text: "Km From",
          align: "right",
          sortable: false,
        },
        {
          text: "Km To",
          align: "right",
          sortable: false,
        },
        {
          text: "Location (lat, long)",
          align: "right",
          sortable: false,
        },
        {
          text: "Amount",
          align: "right",
          sortable: false,
        },
        {
          text: "Status",
          align: "left",
          sortable: false,
        },
      ],
      items: [],
      totalItems: 0,
      queryParams: {
        search: "",
        limit: 300,
        offset: 0,
        company_id: null,
        sub_company_id: null,
        payment_type: null,
        date_from: null,
        date_to: null,
      },
      menu: false,
      menu1: false,
      date_from: this.$dateFormat(now, "YYYY-MM-DD"),
      date_to: this.$dateFormat(now, "YYYY-MM-DD"),
      play_status: false,
      messageDialog: false,
      messageTitle: "",
      messageText: "",
      messageLoading: false,
      action: "",
      viewData: {},
    };
  },
  created: function() {
    this.resetTable();
  },
  computed: {
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      },
    },
    dateFrom: {
      get() {
        this.queryParams.date_from = this.date_from;
        return this.date_from;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_from = value;
        this.date_from = value;
      },
    },
    dateTo: {
      get() {
        this.queryParams.date_to = this.date_to;
        return this.date_to;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_to = value;
        this.date_to = value;
      },
    },
  },
  watch: {
    filterCompany: async function() {
      this.resetTable();
      if (
        this.filterCompany !== null &&
        this.filterCompany !== undefined &&
        this.filterCompany !== ""
      ) {
        this.queryParams.company_id = this.filterCompany;
        this.queryParams.sub_company_id = null;
        this.setFilterSubCompanies();
        this.filterSubCompany = null;
      } else {
        this.queryParams.company_id = null;
        this.queryParams.sub_company_id = null;
        this.setFilterSubCompanies();
        this.filterSubCompany = null;
      }
    },
    filterSubCompany: async function() {
      this.resetTable();
      if (
        this.filterSubCompany !== null &&
        this.filterSubCompany !== undefined &&
        this.filterSubCompany !== ""
      ) {
        this.queryParams.sub_company_id = this.filterSubCompany;
      } else {
        this.queryParams.sub_company_id = null;
      }
    },
    filterPaymentType: async function() {
      this.resetTable();
      if (
        this.filterPaymentType !== null &&
        this.filterPaymentType !== undefined &&
        this.filterPaymentType !== ""
      ) {
        this.queryParams.payment_type = this.filterPaymentType;
      } else {
        this.queryParams.payment_type = null;
      }
    },
  },
  methods: {
    search(data) {
      this.resetTable();
      this.queryParams.search = data;

      this.queryParams.date_from = data ? null : this.date_from;
      this.queryParams.date_to = data ? null : this.date_to;
    },
    async getData() {
      // Start Loading
      this.$store.dispatch("startLoading");

      try {
        // Query Data
        let response = (await Services.getTicketWireless(this.queryParams))
          .data;

        // Assign the reponse data to items to be display on table
        this.items = this.items.concat(response.data);

        // Assign Total number of data
        this.totalItems = response.count;
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async playData() {
      this.items = [];

      this.resetTable();

      // this.$refs.form.reset();

      this.play_status = true;
      this.getData();
    },
    refreshData() {
      this.date_from = this.$dateFormat(now, "YYYY-MM-DD");
      this.date_to = this.$dateFormat(now, "YYYY-MM-DD");
      this.$refs.form.reset();
      this.items = [];
      this.filterCompany = null;
      this.filterSubCompany = null;
      this.filterPaymentType = null;

      this.resetTable();
    },
    resetTable() {
      this.queryParams.limit = 100;
      this.queryParams.offset = 0;

      this.play_status = false;
    },
    async loadMore() {
      if (!this.play_status) return;

      this.queryParams.offset += this.queryParams.limit;

      if (this.queryParams.offset >= this.totalItems) return;

      await this.getData();
    },
    //filter
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setFilterCompanies();
      await this.setFilterSubCompanies();
    },
    async setFilterCompanies() {
      this.filterCompanies = [];

      const items = (await Services.getCompanies({})).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.filterCompanies.push(data);
      }
    },
    async setFilterSubCompanies() {
      this.filterSubCompanies = [];

      const items = (
        await Services.getSubCompanies({
          company_id: this.filterCompany,
        })
      ).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.filterSubCompanies.push(data);
      }
    },
    async downloadExcel() {
      this.$store.dispatch("startLoading");

      let items = [];

      try {
        let response = (
          await Services.getTicketWireless({
            search: this.queryParams.search,
            offset: 0,
            company_id: this.queryParams.company_id,
            sub_company_id: this.queryParams.sub_company_id,
            payment_type: this.queryParams.payment_type,
            date_from: this.queryParams.date_from,
            date_to: this.queryParams.date_to,
          })
        ).data;

        // Assign the reponse data to items to be display on table
        items = response.data;

        this.$store.dispatch("endLoading");
      } catch (error) {
        this.$store.dispatch("endLoading");

        return this.$infoBar({
          type: "error",
          text: "No network or server connection",
        });
      }

      const wscols = [];
      const dataToDownload = [];
      const header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      header.shift();
      //   header.unshift("");
      dataToDownload.push(header);

      for (let i = 0; i < this.headers.length; i++) {
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 35 });
        wscols.push({ wch: 35 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
      }

      // theItem.push(this.items[e].
      // this.$dateFormat
      for (let e = 0; e < items.length; e++) {
        const theItem = [];

        theItem.push(
          items[e].sub_company ? items[e].sub_company.code.toUpperCase() : "--"
        );
        theItem.push(
          items[e].device ? items[e].device.device_serial.toUpperCase() : "--"
        );
        theItem.push(items[e].control_no);
        theItem.push(
          items[e].custom_control_no ? items[e].custom_control_no : "--"
        );
        theItem.push(items[e].trip_no);
        theItem.push(
          items[e].datetimestamp
            ? this.$dateFormat(items[e].datetimestamp, "YYYY-MM-DD")
            : "--"
        );
        theItem.push(
          items[e].datetimestamp
            ? this.$dateFormat(items[e].datetimestamp, "HH:mm")
            : "--"
        );
        theItem.push(items[e].ticket_no);
        theItem.push(items[e].or_no);
        theItem.push(items[e].ticket_type ? "BAGGAGE" : "PASSENGER");
        theItem.push(
          items[e].payment_type
            ? items[e].payment_type.name.toUpperCase()
            : "--"
        );
        theItem.push(items[e].card_no ? items[e].card_no : "--");
        theItem.push(
          items[e].passenger_type
            ? items[e].passenger_type.name.toUpperCase()
            : "--"
        );
        theItem.push(items[e].place_from.toUpperCase());
        theItem.push(items[e].place_to.toUpperCase());
        theItem.push(
          items[e].route
            ? items[e].route.bound
              ? items[e].route.bound.name
                ? items[e].route.bound.name.toUpperCase()
                : "--"
              : "--"
            : "--"
        );

        theItem.push(items[e].km_from);
        theItem.push(items[e].km_to);
        theItem.push(`${items[e].lat}, ${items[e].long}`);
        theItem.push(
          items[e].amount || items[e].amount == 0
            ? items[e].amount.toFixed(2)
            : "--"
        );
        theItem.push(items[e].status ? "CANCELLED" : "NORMAL");

        dataToDownload.push(theItem);
      }

      // don't delete any codes after this comment got it?!

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
    openAlignTicket(data) {
      this.messageDialog = true;
      this.messageTitle = "Ticket Alignment";
      this.messageText = "Are you sure you want to align this ticket?";
      this.action = "align";

      this.viewData = data;
    },
    closeMessageDialog() {
      this.messageDialog = false;
    },
    async saveAlignTicket() {
      this.messageLoading = true;

      let id = null;

      if (this.viewData) id = this.viewData.id;

      try {
        const response = await Services.alignTicket(id);

        if (response.status === 201 || response.status === 204) {
          this.playData();

          this.closeMessageDialog();

          this.$infoBar({
            type: "success",
            text: "Ticket has been aligned.",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        this.$infoBar({
          type: "error",
          text: "No network or server connection",
        });
      }

      this.messageLoading = false;
      this.closeMessageDialog();
    },
  },
};
</script>

<style scoped>
.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
